export enum ButtonRadiusEnum {
  SMALL = 'small',
  BASE = 'base',
  LARGE = 'large',
  CIRCLE = 'circle',
}